import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import {selectStandaloneState} from 'src/app/core/store';
import { StandaloneState } from 'src/app/core/store/standalone';

@Component({
    standalone: false,
  selector: 'app-synchronise-collection-modal',
  templateUrl: './synchronise-collection-modal.component.html',
  styleUrls: ['./synchronise-collection-modal.component.scss']
})
export class SynchroniseCollectionModalComponent implements OnInit {

  constructor(private readonly store: Store<StandaloneState>, 
      private readonly modal: DynamicDialogRef) { }

  ngOnInit() {
      this.store.select(selectStandaloneState)
          .subscribe((standaloneState) => {
            if(standaloneState.isFirstTimeSyncDone && standaloneState.currentCmcVersion != null && standaloneState.currentStandardVersion != null) {
              this.modal.close();
            }
          }
      )
  }

}